<div *ngIf="profile">
  <h4 class="title-profile product-title">Produtos</h4>
  <div style="font-size: 12px;" *ngIf="isAdmin">({{profile.storeSeoName}})</div>
  <table class="table">
    <thead class="table-header-profile">
      <tr>
        <th>Produto</th>
        <th>Plano</th>
        <th>Assinatura</th>
        <th>Próx. Fatura</th>
        <th>Status</th>
        <th>Valor</th>
      </tr>
    </thead>
  </table>
  <div id="acordeon">
    <div class="panel-group" id="accordion">
      <fieldset *ngIf="planItens == null || planItens.length < 2">
      </fieldset>
      <div class="panel panel-border panel-default" [ngClass]="{'invoice-pending': planItem.active === true}"
        *ngFor="let planItem of planItens; let i = index" [attr.data-index]="i" [hidden]="!isAdmin && !planItem.active">
        <div class="panel-content">
          <table class="table invoice-table" style="margin-bottom: 0;">
            <tr class="table-row-profile">
              <td class="text-center">
                <a data-toggle="collapse" href="#collapse{{i}}">
                  <i class="ti-zoom-in"></i>
                </a>
              </td>
              <td>
                {{ i===0 ? "Polen Direto (1 Compra = 1 Doação)" : planItem.name }}
              </td>
              <td>
                {{ profile.planName }}
              </td>
              <td>
                {{getPeriod(planItem.period)}}
              </td>
              <td>
                <p *ngIf="!profile.nextInvoiceDate" class="form-control-static">-</p>
                <p *ngIf="profile.nextInvoiceDate" class="form-control-static">
                  {{i===0 ? (profile.nextInvoiceDate | date:'dd/MM/yyyy' : 'UTC 0') : "-"}}
                </p>
              </td>
              <td>
                <a *ngIf="planItem.active" class="btn btn-xs btn-point" style="color: #66615b;"><i
                    class="fa fa-circle point-success"></i>&nbsp;ativo
                </a>
                <a *ngIf="!planItem.active" class="btn btn-xs btn-point" style="color: #66615b;"><i
                    class="fa fa-circle point-danger"></i>&nbsp;desativado
                </a>
              </td>
              <td>
                R$
                {{ planItem.price | number: '.2-2' }}
                &nbsp;
              </td>
            </tr>
          </table>
        </div>
        <div id="collapse{{i}}" class="panel-collapse collapse">
          <p class="description" *ngIf="planItem.description!==null">
            {{planItem.description}}
          </p>
          <div class="panel-body" [ngClass]="{'invoice-pending-body': planItem.active === true}">
            <div class="plan-card card-inside-profile" *ngIf="i===0">
              <div class="plan-card-text">
                <h4>Plano</h4>
                <span>{{planItem.planName}}</span>
                <small *ngIf="isAdmin">({{planItem.planSeoName}})</small>
              </div>
              <a *ngIf="i===0" class="btn btn-success btn-fill" href="/#/profile/plans">Alterar Plano</a>
              <a *ngIf="isAdmin" class="btn btn-success btn-fill" (click)="editPlanItem(planItem)">[A]
                Editar</a>
            </div>
            <div class="plan-card card-inside-profile" *ngIf="isAdmin && i>0">
              <div class="plan-card-text">
                <h4>Plano</h4>
                <span>{{planItem.planName}}</span>
                <small *ngIf="isAdmin">({{planItem.planSeoName}})</small>
              </div>
              <a class="btn btn-danger btn-sm" (click)="deletePlanItem(planItem)">[A] Deletar</a>
              <a class="btn btn-success btn-fill" (click)="editPlanItem(planItem)">[A] Editar</a>
            </div>
            <div class="plan-card">
              <h4 class="investment">Investimento <span>R${{ planItem.price | number: '.2-2' }}</span></h4>
            </div>
          </div>
          <div class="panel-body">
            <div class="plan-card">
              <div class="plan-card-text">
                <h4>Data do seu plano</h4>
                <div class="plan-date">
                  <span class="date-start">Data Inicial: {{planItem.startDate | date:'dd/MM/yyyy' : 'UTC 0'}}</span>
                  <span class="date-end">Data final:
                    {{planItem.endDate ? (planItem.endDate |  date:'dd/MM/yyyy' : 'UTC 0') : "Renovação automática"}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a *ngIf="isAdmin" class="btn btn-info btn-fill" (click)="editPlanItem(null)">[A] Adiconar Novos Items</a>
  </div>
  <plan-editor (answer)="getAnswer('planEditor', $event)" [seoUrl]="planEditorSeoUrl"
    [planItemId]="planEditorPlanItemId">
  </plan-editor>
</div>